import { get, post, put, del } from './request';

export async function authenticateWithUserService({ userService }, { token }) {
  const response = await fetch(
    `${userService}/trueprodigy/auth/token/nonpublic`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    const json = await response.json();
    throw new Error(json?.message || json?.warning || response.status);
  }

  const body = await response.json();
  return body;
}

export async function fetchAuth0OrganizationId(
  { userService },
  { organizationName },
) {
  const url = `${userService}/trueprodigy/user/auth0/organization/id?organizationName=${organizationName}`;
  const { body } = await get(null, url);
  return body;
}

export async function resetMfa(
  { userService },
  { email, authenticationToken },
) {
    const { body } = await del(
      authenticationToken,
      `${userService}/trueprodigy/user/auth0/mfa?email=${email}`,
    );
    return body;
}

export async function checkToken({ userService }, { token }) {
  try {
    const { body } = await post(
      token,
      `${userService}/trueprodigy/auth/token/verify`,
      undefined,
      {
        contentType:
          'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
      },
    );
    return body;
  } catch (error) {
    if (error.body.httpStatus === 401) {
      throw 'incorrect';
    }
    throw error;
  }
}

export async function setPassword({ userService }, { token, newPassword }) {
  try {
    const { body } = await put(
      token,
      `${userService}/trueprodigy/user/setpassword`,
      { newPassword },
    );
    return body;
  } catch (error) {
    if (error.body.httpStatus === 401) {
      throw 'incorrect';
    }
    throw error;
  }
}
